import request from '@/utils/request'

const portalApi = process.env.VUE_APP_PORTAL_API

// 根据文章分类别名获取文章分页列表
export function getArticleListByAliasApi(params) {
  return request({
    url: portalApi + `/articles/page`,
    method: 'get',
    params
  })
}

// 获取文章详情
export function getArticleApi(articleId) {
  return request({
    url: portalApi + `/articles/${articleId}`,
    method: 'get'
  })
}
